import { Field, RichText, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { useEffect } from 'react';
import { ComponentProps } from 'lib/component-props';

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/bundle";
import Image from 'next/image';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import { Link as JssLink } from "@sitecore-jss/sitecore-jss-nextjs";
import { useMediaQuery } from 'react-responsive';
import { Swiper, SwiperSlide } from 'swiper/react';
import { A11y, Mousewheel, Pagination } from 'swiper';
import { useRouter } from 'next/router';

type CommisionProps = ComponentProps & {
  fields: {
    childItems: any;
    titleSection: Field<string>;
    description: Field<string>;
  };
  locale: string;
  lang: string;
};
gsap.registerPlugin(ScrollTrigger);
const Commision = (props: CommisionProps): JSX.Element => {
  const router = useRouter();
  const isMobile = useMediaQuery({
    query: "(max-width: 768px)"
  })
  useEffect(()=>{
    if(!isMobile){
      gsap.to('.left',{
        x: isMobile ? -500 : -2000
      })
      gsap.to('.right',{
        x: isMobile ? 500 : 2000
      })
      ScrollTrigger.batch(".left", {
        onEnter: batch => gsap.to(batch, {opacity: 1, x: 0, duration: isMobile ? 1.5 : 4, stagger: {each: 0.2}, overwrite: true}),
        onEnterBack: batch => gsap.to(batch, {opacity: 1, x: 0,duration: isMobile ? 1.5 : 4, stagger: 0.2, overwrite: true}),
      });
      ScrollTrigger.batch(".right", {
        onEnter: batch => gsap.to(batch, {opacity: 1, x: 0, duration: isMobile ? 1.5: 4, stagger: {each: 0.2}, overwrite: true}),
        onEnterBack: batch => gsap.to(batch, {opacity: 1, x: 0, duration: isMobile ? 1.5 : 4, stagger: 0.2, overwrite: true}),
      });
    }
  })
  return(
  <>
    <div className={`w-full min-h-full smooth-wrapper section-spacing ${props?.locale == props?.lang? "rtl": ""} ${router.asPath == "/Modules/Pages/Cultural-system" ? " pt-12" : ""}`}>
      <div className="responsive smooth-content flex flex-col gap-2 sm:gap-8">
        <h1 className="animate-top text-[#102938]   xl:text-4xl text-2xl font-bold">{props?.fields?.titleSection?.value}</h1>
        <div className="animate-top text-description p-space">
          <RichText field={props?.fields?.description} />
        </div>
      </div>
      <div className='responsive logos-container'>
        {isMobile && <div className='w-full relative'>
          <Swiper
          slidesPerView={1}
          spaceBetween={30}
          speed={ 700 }
          allowTouchMove={true}
          resistanceRatio={0}
          // loop={true}
          effect={ "slide" }
          pagination={{clickable: true}}
          mousewheel={{thresholdDelta: 100, forceToAxis: true}}
          dir={props?.locale == props?.lang? "rtl": ""}
          key={props?.locale == props?.lang? "true": "false"}
          modules={[Pagination, Mousewheel, A11y]}
          a11y={{
            enabled: true,
            paginationBulletMessage: "Go to slide {{index}}",
          }}
          className="commission-swiper-pagination-bullet min-h-[450px] flex items-center"
          // scrollbar={{ draggable: false }}
          >
            {props?.fields?.childItems?.map((item: any, index: number)=>{
              return(
                <SwiperSlide key={index}>

                    <div className='w-full sm:w-[90%] mt-0 mx-auto overflow-visible'>
                    <JssLink
                      field={item?.fields?.ButtonUrl?.value}
                    >
                      <Image
                        loading={"eager"}
                        src={item.fields?.LogoImage?.value?.src}
                        alt={(item.fields?.LogoImage?.value?.alt ?? "").trim() || "Commission logo"}
                        width={"300px"}
                        height={"103px"}
                        layout="responsive"
                        objectFit='contain'
                        className="pointer-events-none"
                        />
                    </JssLink>
                    </div>
                </SwiperSlide>
              )
            })}
          </Swiper>
        </div>}
        {!isMobile && <div className="hidden md:grid md:grid-cols-4 gap-12 md:gap-0 my-4 sm:my-12 md:my-24 left">
                  asfd
          {
            Array.from({length: 4}, (_, index: number)=>{
              return(
                <div className="">
                  <span className='cursor-pointer h-auto'>
                    <JssLink
                      field={props?.fields?.childItems[index]?.fields?.ButtonUrl?.value}
                    >
                    <div className='group logoImage transition-all duration-500 ease-in-out
                            sm:hover:scale-110'>
                        <div className="coloredLogoImage group-hover:!block">
                          <Image
                            loading={"eager"}
                            src={props?.fields?.childItems[index]?.fields?.LogoImage?.value?.src}
                            alt={(props?.fields?.childItems[index]?.fields?.LogoImage?.value?.alt ?? "").trim() || "Commission logo"}
                            width={"340px"}
                            height={"103px"}
                            layout="responsive"
                            objectFit='contain'
                            className=""
                            />
                        </div>
                        <div className='secondLogoImage hidden group-hover:!hidden'>
                          <Image
                            loading={"eager"}
                            src={props?.fields?.childItems[index]?.fields?.SecondLogoImage?.value?.src}
                            alt={(props?.fields?.childItems[index]?.fields?.SecondLogoImage?.value?.alt ?? "").trim() || "Commission logo"}
                            width={"340px"}
                            height={"103px"}
                            layout="responsive"
                            objectFit='contain'
                            className=""
                            />
                        </div>
                      </div>
                    </JssLink>
                  </span>
                </div>
              )
            })
          }
        </div>}
        {!isMobile && <div className=" 2xl:px-10 hidden md:grid md:grid-cols-3 gap-6 md:gap-0 my-8 sm:my-12 md:my-24 right">
          {
            Array.from({length: 3}, (_, index: number)=>{
              return(
                <div className={` ${index == 2 ? " px-11" : index == 1 ? `${props.locale == props.lang ? "pl-6 pr-11" : "pr-6 pl-11"} 2xl:mt-0 xl:mt-[-4px] ` : index == 0 ? " mt-[-14px] 2xl:px-0 xl:px-3  " : ""}`}>
                  <span className='cursor-pointer h-auto'>
                  <JssLink
                      field={props?.fields?.childItems[index+4]?.fields?.ButtonUrl?.value}
                    >
                      <div className='group logoImage transition-all duration-500 ease-in-out
                            sm:hover:scale-110'>
                        <div className={`coloredLogoImage group-hover:!block ${isMobile ? "w-full h-auto sm:max-w-[256px] sm:max-h-[103px] [&>span]:!w-full":""}`}>
                          <Image
                            loading={"eager"}
                            src={props?.fields?.childItems[index+4]?.fields?.LogoImage?.value?.src}
                            alt={(props?.fields?.childItems[index+4]?.fields?.LogoImage?.value?.alt ?? "").trim() || "Commission logo"}
                            width={"277px"}
                            height={"103px"}
                            layout={"responsive"}
                            objectFit='contain'
                            className=""
                            />
                        </div>
                        <div className={`secondLogoImage hidden group-hover:!hidden ${isMobile ? "w-full h-auto sm:max-w-[256px] sm:max-h-[103px]":""}`}>
                          <Image
                            loading={"eager"}
                            src={props?.fields?.childItems[index+4]?.fields?.SecondLogoImage?.value?.src}
                            alt={(props?.fields?.childItems[index+4]?.fields?.SecondLogoImage?.value?.alt ?? "").trim() || "Commission logo"}
                            width={"277px"}
                            height={"103px"}
                            layout={"responsive"}
                            objectFit='contain'
                            className=""
                            />
                        </div>
                      </div>
                    </JssLink>
                  </span>
                </div>
              )
            })
          }
        </div>}
        {!isMobile && <div className="hidden md:grid md:grid-cols-4 my-4 gap-12 md:gap-0 sm:my-12 md:my-24 left">
          {
            Array.from({length: 4}, (_, index: number)=>{
              return(
                <div className="">
                  <span className='cursor-pointer'>
                    <JssLink
                        field={props?.fields?.childItems[index+7]?.fields?.ButtonUrl?.value}
                      >
                        <div className='group logoImage transition-all duration-500 ease-in-out
                              sm:hover:scale-110'>
                          <div className="coloredLogoImage group-hover:!block">
                            <Image
                              loading={"eager"}
                              src={props?.fields?.childItems[index+7]?.fields?.LogoImage?.value?.src}
                              alt={(props?.fields?.childItems[index+7]?.fields?.LogoImage?.value?.alt ?? "").trim() || "Commission logo"}
                              width={"340px"}
                              height={"103px"}
                              layout="responsive"
                              objectFit='contain'
                              className=""
                              />
                          </div>
                          <div className='secondLogoImage hidden group-hover:!hidden'>
                            <Image
                              loading={"eager"}
                              src={props?.fields?.childItems[index+7]?.fields?.SecondLogoImage?.value?.src}
                              alt={(props?.fields?.childItems[index+7]?.fields?.SecondLogoImage?.value?.alt ?? "").trim() || "Commission logo"}
                              width={"340px"}
                              height={"103px"}
                              layout="responsive"
                              objectFit='contain'
                              className=""
                              />
                          </div>
                        </div>
                    </JssLink>
                  </span>
                </div>
              )
            })
          }
        </div>}
    </div>
    </div>
  </>
)

};

export default withDatasourceCheck()<CommisionProps>(Commision);